import { render } from "./PrintFooterDesign2.vue?vue&type=template&id=0d3dfcea&scoped=true"
import script from "./PrintFooterDesign2.vue?vue&type=script&lang=js"
export * from "./PrintFooterDesign2.vue?vue&type=script&lang=js"

import "./PrintFooterDesign2.vue?vue&type=style&index=0&id=0d3dfcea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3dfcea"]])

export default __exports__